import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth, db } from '../lib/firebase';
import {
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut as firebaseSignOut,
} from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchProfile = async (uid) => {
    const snap = await getDoc(doc(db, 'user_profiles', uid));
    setProfile(snap.exists() ? { id: uid, ...snap.data() } : null);
  };

  useEffect(() => {
    if (!auth) {
      setLoading(false);
      return;
    }
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      setUser(firebaseUser ?? null);
      if (firebaseUser) await fetchProfile(firebaseUser.uid);
      else setProfile(null);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const signIn = (email, password) =>
    auth
      ? signInWithEmailAndPassword(auth, email, password)
      : Promise.reject(new Error('Firebase not configured.'));

  const signOut = () => (auth ? firebaseSignOut(auth) : Promise.resolve());

  const refreshProfile = () => user && auth && fetchProfile(user.uid);

  return (
    <AuthContext.Provider value={{ user, profile, loading, signIn, signOut, refreshProfile }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
